import { a as __rest, _ as __assign, w as withSharedProps } from './withSharedProps-c76ac46d.js';
import React from 'react';
import { s as styleInject, d as defaultProps } from './style-inject.es-bc4b7987.js';

var css_248z = "@keyframes spinners-react-dotted-center{0%,15%,85%,to{transform:scale(0)}40%,50%{transform:scale(1)}84%{transform:scale(.45)}}@keyframes spinners-react-dotted-shrink{50%{transform:translate(0)}}";
styleInject(css_248z);

var coords = [
    { x: 22, y: -20 },
    { x: 29, y: 0 },
    { x: 22, y: 20 },
    { x: 0, y: 30 },
    { x: -23, y: 20 },
    { x: -30, y: 0 },
    { x: -23, y: -20 },
    { x: 0, y: -30 },
];
var Component = function (_a) {
    var speed = _a.speed, still = _a.still, thickness = _a.thickness, svgProps = __rest(_a, ["speed", "still", "thickness"]);
    var duration = 200 / speed;
    var generateCircleStyle = function (i) { return (!still
        ? { animation: "spinners-react-dotted-shrink " + duration + "s cubic-bezier(0, 0.9, 0, 0.9) " + (duration / 20) * i + "s infinite" }
        : {}); };
    var centerStyle = !still
        ? {
            animation: "spinners-react-dotted-center " + duration + "s ease-out infinite",
            transformOrigin: 'center',
        }
        : { display: 'none' };
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 66 66" }, svgProps),
        coords.map(function (c, i) { return (React.createElement("circle", { key: c.x + "-" + c.y, cx: "33", cy: "33", fill: "currentColor", r: 3 * (thickness / 100), style: __assign({ transform: "translate(" + c.x + "px, " + c.y + "px)" }, generateCircleStyle(i)) })); }),
        React.createElement("circle", { cx: "33", cy: "33", fill: "currentColor", r: 6 * (thickness / 100), style: centerStyle })));
};
Component.defaultProps = defaultProps;
var SpinnerDotted = withSharedProps(Component);

export { Component, SpinnerDotted };
